import type { Entregador } from "../../../services/entregadores"

export interface EntregadoresModel {
    lista: Entregador[]
}

export const EntregadoresInicial: EntregadoresModel = {
    lista: [],
}
